// Ausblendung am Rand horizontal scrollender Leisten (PillTabs, Vorschlags-Pills): setzt
// data-fade="start|end|both" am Element, ohne React-State (kein Re-Render beim Scrollen).
import { useEffect, type RefObject } from 'react';

export function updateFade(el: HTMLElement) {
  const max = el.scrollWidth - el.clientWidth;
  const atStart = el.scrollLeft <= 1;
  const atEnd = el.scrollLeft >= max - 1;
  const fade = max <= 1 ? '' : atStart ? 'end' : atEnd ? 'start' : 'both';
  if (fade) el.dataset.fade = fade;
  else delete el.dataset.fade;
}

export function useScrollFade(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => updateFade(el);
    update();
    el.addEventListener('scroll', update, { passive: true });
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
    observer?.observe(el);
    return () => {
      el.removeEventListener('scroll', update);
      observer?.disconnect();
    };
  }, [ref]);
}

/** Scrollt das aktive Kind in Sicht (nur innerhalb der Leiste, nicht die Seite). */
export function scrollChildIntoView(container: HTMLElement | null, selector: string) {
  const child = container?.querySelector<HTMLElement>(selector);
  if (!container || !child) return;
  const left = child.offsetLeft - container.offsetLeft;
  const right = left + child.offsetWidth;
  if (left < container.scrollLeft) container.scrollLeft = left - 24;
  else if (right > container.scrollLeft + container.clientWidth)
    container.scrollLeft = right - container.clientWidth + 24;
}
